import { BaseProvider } from 'src/app/core/services/base-provider';
import * as i0 from "@angular/core";
import * as i1 from "../../../core/services/globals.service";
import * as i2 from "@angular/common/http";
import * as i3 from "../../../core/services/ls-helper.service";
import * as i4 from "../../../core/services/auth.service";
import * as i5 from "./transaction.service";
export class TransactionSupDocsService extends BaseProvider {
    constructor(globals, http, ls, authService, transactionService) {
        super();
        this.globals = globals;
        this.http = http;
        this.ls = ls;
        this.authService = authService;
        this.transactionService = transactionService;
        this.mode = 'list';
        this.processId = 0;
        this.canManageDocs = false;
        this.baseUrl = 'userProcessSupplementaryDocument';
    }
    getDocs() {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + 'userProcessDocument/userProcessId/' + this.processId;
            this.http.get(this.url)
                .subscribe((data) => {
                if (this.page === 1) {
                    this.list = data.Data;
                }
                else {
                    this.pushItems(data.Data);
                }
                resolve(data);
            }, err => { reject(err); });
        });
    }
    newGetDocs() {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + 'userProcessDocument/userProcessId/' + this.processId;
            this.http.get(this.url)
                .subscribe((data) => {
                if (this.page === 1) {
                    this.list = data.Data;
                }
                else {
                    this.pushItems(data.Data);
                }
                resolve(data);
            }, err => { reject(err); });
        });
    }
    createDoc(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl;
            this.http
                .post(this.url, params)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    update(data) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/' + data.Id;
            this.http
                .put(this.url, data)
                .subscribe((resp) => {
                this.updateItem(data);
                resolve(resp);
            }, err => { reject(err); });
        });
    }
    delete(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl +
                '/process/' + params.UserProcessId +
                '/doc/' + params.Id;
            this.http
                .delete(this.url)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    canEdit() {
        // User has 'can manage documents' policy
        // Transaction is not finished
        const hasPolicy = false;
        const transactionIsFinalized = true;
        // hasPolicy = this.authService.hasPolicyBool("CanManageDocuments");
        return (!this.transactionService.itemToEdit.IsFinalized
            &&
                (this.transactionService.itemToEdit.AssignedToCurrentUser
                    ||
                        this.transactionService.itemToEdit.CreatedByCurrentUser));
    }
    canView() {
        // User has 'can view documents' policy
        let hasPolicy = false;
        hasPolicy = this.authService.hasPolicyBool('CanViewDocuments');
        return hasPolicy;
    }
    canManage() {
        // User has 'can view documents' policy
        let hasPolicy = false;
        hasPolicy = this.authService.hasPolicyBool('CanManageDocuments');
        this.canManageDocs = hasPolicy;
        return hasPolicy;
    }
}
TransactionSupDocsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TransactionSupDocsService_Factory() { return new TransactionSupDocsService(i0.ɵɵinject(i1.GlobalsService), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(i3.LsHelperService), i0.ɵɵinject(i4.AuthService), i0.ɵɵinject(i5.TransactionService)); }, token: TransactionSupDocsService, providedIn: "root" });
